import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react"

import LockingSystemPermission from "../../../types/LockingSystemPermission"
import {useAuth} from "../../../contexts/AuthContext";
import NumberFormat from "../../common/Text/NumberFormat";

export interface componentProps {
    item: LockingSystemPermission
}

const ViewItemGroupLinked: React.FC<componentProps> = ({item} ) => {

    const { hasOption: hasUserOption} = useAuth()
    const {t} = useTranslation()

    const keysCount:  number = item !== undefined ? item.counts?.keys  || 0 : 0
    const locksCount: number = item !== undefined ? item.counts?.locks || 0 : 0

    return (
        <IonItemGroup>
            <IonItemDivider>{t('common.linked')}</IonItemDivider>
            <IonItem lines="full" button={keysCount > 0} detail={keysCount > 0}
                     routerLink={'/locking-system-permissions/' + item.id + '/keys'}>
                <IonLabel>{t('keys.title_list')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    <NumberFormat number={keysCount} />
                </IonNote>
            </IonItem>
            {hasUserOption('canViewLocks') &&
            <IonItem lines="full" button={locksCount > 0} detail={locksCount > 0}
                     routerLink={'/locking-system-permissions/' + item.id + '/locks'}>
                <IonLabel>{t('locks.title_list')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">
                    <NumberFormat number={locksCount} />
                </IonNote>
            </IonItem>
            }
            {item.lockingSystemZone && hasUserOption('canViewLockingSystemZones') &&
                <IonItem lines="full" button detail={true}
                         routerLink={'/locking-system-zones/' + item.lockingSystemZone.id + '/view'}>
                    <IonLabel>{t('locking-system-zones.title_item')}</IonLabel>
                    <IonNote className="ion-padding-vertical" slot="end">
                        {item.lockingSystemZone.name || '-'}
                    </IonNote>
                </IonItem>
            }
        </IonItemGroup>
    )
}

export default ViewItemGroupLinked